import { Component } from '@angular/core';
import { EntryService } from 'src/app/services/entry.service';
import { LocaleService } from '../../localization/locale.service';
import { IEntryKontakt } from 'src/rest-interfaces/IEntryKontakt';
import { ILocalizedComponent } from 'src/app/ILocalizedComponent';
import { Title } from '@angular/platform-browser';
import { generalAnimations } from 'src/app/_animations/general.animations';

@Component( {
  selector: 'app-kontakt',
  templateUrl: './kontakt.component.html',
  animations: [ generalAnimations ]
} )
export class KontaktComponent implements ILocalizedComponent {
  public content: IEntryKontakt;

  constructor(
    private entrySvc: EntryService,
    private localeSvc: LocaleService,
    private title: Title
  ) {
    this.entrySvc.entry<IEntryKontakt>( this.localeSvc.Locale === 'en' ? 'contact' : 'kontakt' ).subscribe(
      t => {
        this.content = t;
        this.title.setTitle( 'PIRMIN JUNG - ' + ( typeof t.metaTitle === 'string' && t.metaTitle.length > 0 ? t.metaTitle : t.title ) );
      },
      () => { this.localeSvc.navigateToHome(); }
    );
  }

  public getLocaleChangeUrl( targetLocale: string ): string {
    const locUrlProperty = 'url_' + targetLocale;
    if ( this.content && this.content.hasOwnProperty( locUrlProperty ) ) {
      return this.content[ locUrlProperty ];
    }
  }
}
